module.exports = __webpack_public_path__ + "assets/img/2022_01.fe75d1fe.png";